import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiErrorDetail } from "../lib/api";
import LegalFooter from "../components/LegalFooter";

export default function Signup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: "", company_name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const change = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form);
      navigate("/onboarding", { replace: true });
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card" data-testid="signup-card">
        <div className="flex items-center gap-2 mb-6">
          <span className="sidebar-brand-mark" />
          <span className="text-[18px] font-bold tracking-tight">Parapet</span>
        </div>
        <h1 className="mb-1">Create an account</h1>
        <p className="text-[13px] mb-6" style={{ color: "var(--parapet-text-secondary)" }}>
          Start finding MOD opportunities matched to your company.
        </p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="p-label">Your name</label>
            <input className="p-input" value={form.full_name} onChange={change("full_name")} required data-testid="signup-name-input" />
          </div>
          <div>
            <label className="p-label">Company name</label>
            <input className="p-input" value={form.company_name} onChange={change("company_name")} required data-testid="signup-company-input" />
            <div className="p-help">You can rename or add teammates later.</div>
          </div>
          <div>
            <label className="p-label">Work email</label>
            <input type="email" className="p-input" value={form.email} onChange={change("email")} required data-testid="signup-email-input" />
          </div>
          <div>
            <label className="p-label">Password</label>
            <input type="password" className="p-input" value={form.password} onChange={change("password")} required minLength={8} data-testid="signup-password-input" />
            <div className="p-help">Min 8 characters.</div>
          </div>
          {error && <div className="text-[12px] p-2 rounded border" style={{ borderColor: "#111" }} data-testid="signup-error">{error}</div>}
          <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="signup-submit-button">
            {loading ? "Creating account…" : "Create account"}
          </button>
        </form>
        <p className="text-[12px] mt-6 text-center" style={{ color: "var(--parapet-text-secondary)" }}>
          Have an account?{" "}
          <Link to="/login" className="underline" data-testid="link-login">Sign in</Link>
        </p>
      </div>
      <LegalFooter variant="fixed" />
    </div>
  );
}
